import { Injectable } from '@angular/core';
import { CustomerModel } from 'src/app/models/customer-model';
import { UserSessionService } from '../user-session/user-session.service';
import { WebservicesService } from '../webservices/webservices.service';

@Injectable({
  providedIn: 'root'
})

export class DepositService {

  public customer: CustomerModel;

  constructor(
    public userSessionService: UserSessionService,
    public webservicesService: WebservicesService,
  ){
    this.userSessionService.getCustomer().subscribe(customer => {
      this.customer = customer;
    });
  }

  callGetTotalDeposits() {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSessionService.sessionToken,
    }

    return this.webservicesService.post('cashier/get-total-deposits', obj);
  }

  callSendTotalDeposits() {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSessionService.sessionToken,
    }

    return this.webservicesService.post('cashier/send-total-deposits', obj);
  }

  callPaypalConfirm(obj) {
    return this.webservicesService.post('cashier/paypal-confirm', obj);
  }

  checkDepositStatus(payment_request_id) {
    let obj: any = {
        payment_request_id: payment_request_id
    }
    return this.webservicesService.post('cashier/check-deposit-status', obj);
  }

  getPaypalToken(amount, currency = 'USD', confirmLink = "", cancelLink = "") {
    let obj: any = {}
    obj.amount = amount;
    obj.currency = currency;
    obj.confirm_url = confirmLink;
    obj.cancel_url = cancelLink;

    return this.webservicesService.get('cashier/get-paypal-token', obj);
  }

  callDepositLimitConfirm(customerId) {
    customerId = (!customerId) ? this.customer.customerId : customerId;
    let obj: any = {
        customer_id: customerId,
        session_token: this.userSessionService.sessionToken
    }

    return this.webservicesService.post('cashier/deposit-limit-confirm', obj);
  }

  getBraintreeToken(amount, paymentRequestID){
    let obj: any = {
        amount: amount,
        payment_request_id: paymentRequestID,
        customer_id: this.customer.customerId,
        session_token: this.userSessionService.sessionToken
    }
    return this.webservicesService.get('cashier/get-braintree-token', obj);
  }

  callHasSightlineAccount() {
    let obj: any = {
        customer_id: this.customer.customerId,
        session_token: this.userSessionService.sessionToken
    }

    return this.webservicesService.get('cashier/has-sightline-account', obj);
  }

}
